import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Drawer, Modal, ScrollArea } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';
import { Tabs } from 'antd';
import EgiftStatus from 'components/Atoms/LoyaltyStore/ChangeGiftStep/Egift';
import NotifyFailure from 'components/Atoms/LoyaltyStore/ChangeGiftStep/Notify/failure';
import NotifySuccess from 'components/Atoms/LoyaltyStore/ChangeGiftStep/Notify/success';
import PhysicalGift from 'components/Atoms/LoyaltyStore/ChangeGiftStep/PhysicalGift';
import { cvMaSanpham } from 'components/Atoms/LoyaltyStore/DetailUseGiftModal';
import HorizontalGift from 'components/Atoms/LoyaltyStore/HorizontalGift';
import Location from 'components/Atoms/LoyaltyStore/Location';
import { RenderHTML } from 'components/Atoms/LoyaltyStore/RenderHtml';
import VerticalGift from 'components/Atoms/LoyaltyStore/VerticalGift';
import { RoutesV1 } from 'constants/appRoutes';
import { invalidChangeGiftType } from 'constants/index';
import { dateFormat } from 'functions';
import useDevice from 'hooks/useDevice';
import useValidConditionChangeGift from 'hooks/useValidConditionChangeGift';
import { getProfileByC } from 'model/actions/LoyaltyAccountInfoAction';
import {
  getListMyGiftUnusedOwnAction,
  getListMyGiftUsedOwnAction,
} from 'model/actions/LoyaltyGiftAction';
import { genLinkBhbv } from 'model/services/LoyaltyAccountInfoService';
import { createRedeemTransaction } from 'model/services/LoyaltyGiftService';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { formatTimeString, format_curency } from 'utils';

const TabsStyle = styled.div`
  padding: 0 24px;
  border-bottom: 1px solid #d9d9d9;
  .ant-tabs-tab {
    padding: 6px 24px;
    font-weight: 500;
    margin: 0;
  }
  .ant-tabs-ink-bar {
    border-bottom: 4px solid #0090f0;
  }
`;

const GiftItem = ({ giftData, horizontal = false }) => {
  const {
    thirdPartyContent: intro = ' ',
    thirdPartyNote: condition = ' ',
    office,
    requiredCoin,
    remainingQuantity,
  } = giftData.giftInfor;
  const infoProfile = useSelector((state) => state.userProfile.data);

  const { date, month, year } = formatTimeString(giftData.giftInfor.effectiveTo);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileUser = useSelector((state) => state.LoyaltyAccountInfoReducer.profilebyc);

  const [isOpenDetailInfo, setIsOpenDetailInfo] = useState(false);
  const [tabActive, setTabActive] = useState('1');
  const [quantity, setQuantity] = useState(1);
  const [isShowTabBubble, setShowTabBubble] = useState(false);
  const [isFocus, setIsFocus] = useState(1);
  const [statusGift, setStatusGift] = useState({
    isOpen: false,
    isSuccess: false,
    isFail: false,
    isLoading: false,
    resson: '',
    dataCreateRedeemTransaction: null,
  });
  const { valid, invalidType } = useValidConditionChangeGift(
    remainingQuantity,
    quantity,
    requiredCoin
  );

  const autoHideMessage = useCallback(
    () =>
      setTimeout(
        () =>
          setStatusGift({
            isOpen: false,
            isSuccess: false,
            isFail: false,
            isLoading: false,
            dataCreateRedeemTransaction: null,
            resson: '',
          }),
        12000
      ),
    [giftData]
  );

  const infoRef = useRef();
  const conditionRef = useRef();
  const locationRef = useRef();

  const { ref, entry } = useIntersection({
    threshold: 0.2,
  });
  const { ref: infoRefFocus, entry: entryInfoFocus } = useIntersection({
    threshold: 0.5,
  });
  const { ref: conditionRefFocus, entry: entryConditionFocus } = useIntersection({
    threshold: 0.5,
  });
  const { ref: locationRefFocus, entry: entryLocationFocus } = useIntersection({
    threshold: 0.5,
  });

  const { isMobile } = useDevice();

  // const onDisplayAllChallengeList = (values) => {
  //   window.location.href = '/#/pages/loyalty-voucher';
  // };

  const handleChangeGift = () => {
    if (valid) {
      setStatusGift((prev) => {
        return {
          ...prev,
          isOpen: true,
        };
      });
    } else {
      if (invalidType === invalidChangeGiftType.LACK_POINT) {
        setStatusGift((prev) => {
          return {
            ...prev,
            isFail: true,
            resson: 'Không đủ điểm đổi quà. Quý khách vui lòng lựa chọn quà tặng phù hợp khác.',
          };
        });
      } else if (invalidType === invalidChangeGiftType.LACK_QUANTITY) {
        setStatusGift((prev) => {
          return {
            ...prev,
            isFail: true,
            resson: 'Không đủ số lượng quà. Quý khách vui lòng lựa chọn quà tặng phù hợp khác.',
          };
        });
      }
    }
  };

  const handleShowGift = () => {
    setIsOpenDetailInfo(false);
    navigate(`${RoutesV1.loyaltyStore}#openGift=true`);
  };

  const handleSubmitChangeGift = (data, type) => {
    const payload = {
      ...data,
      memberCode: profileUser?.obj?.code || '',
      quantity,
      totalAmount: quantity * giftData.giftInfor.requiredCoin,
    };
    setStatusGift((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    });
    createRedeemTransaction(payload)
      .then((res) => {
        if (res.obj.messages === 'Success') {
          setStatusGift((prev) => {
            return {
              ...prev,
              dataCreateRedeemTransaction: res.obj.items[0],
              isSuccess: true,
              isLoading: false,
            };
          });
          dispatch(getProfileByC(profileUser.obj.code));
          dispatch(
            getListMyGiftUsedOwnAction({ memberCodeFilter: profileUser.obj.code, selectTab: 2 })
          );
          dispatch(
            getListMyGiftUnusedOwnAction({ memberCodeFilter: profileUser.obj.code, selectTab: 1 })
          );
        } else {
          setStatusGift((prev) => {
            return {
              ...prev,
              isFail: true,
              isLoading: false,
              resson: res.obj.messages,
            };
          });
        }
      })
      .catch((err) => {
        setStatusGift((prev) => {
          return {
            ...prev,
            isFail: true,
            isLoading: false,
            resson: err,
          };
        });
      });
  };

  const fillInInformation = () => {
    setStatusGift((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    });
    const payload = {
      hoTen: infoProfile?.userName,
      ngaySinh: dateFormat(infoProfile?.clientDateOfBirth),
      canCuoc: infoProfile?.userClientIdnumber,
      soDienThoai: infoProfile?.userMobifone,
      maGiamGia: statusGift.dataCreateRedeemTransaction.code,
      ngayBatDau: dateFormat(statusGift.dataCreateRedeemTransaction.date),
      ngayKetThuc: dateFormat(statusGift.dataCreateRedeemTransaction.eGift.expiredDate),
      userCode: infoProfile?.userCode,
      maSanPham: cvMaSanpham(giftData?.giftInfor?.name.toLowerCase()),
    };
    genLinkBhbv(payload)
      .then((res) => {
        if (+res.responseStatus === 1) {
          setStatusGift((prev) => {
            return {
              ...prev,
              isLoading: false,
            };
          });
          window.open(res.obj.linkMuaSanPham);
        } else {
          setStatusGift((prev) => {
            return {
              ...prev,
              isFail: true,
              isLoading: false,
              resson: res.responseMessage,
            };
          });
        }
      })
      .catch((err) => {
        setStatusGift((prev) => {
          return {
            ...prev,
            isFail: true,
            isLoading: false,
            resson: err,
          };
        });
      });
  };

  useEffect(() => {
    if (entry) {
      setShowTabBubble(!entry.isIntersecting);
    }
    if (entryInfoFocus?.isIntersecting) {
      setIsFocus(1);
    }
    if (entryConditionFocus?.isIntersecting) {
      setIsFocus(2);
    }
    if (entryLocationFocus?.isIntersecting) {
      setIsFocus(3);
    }
  }, [entry, entryInfoFocus, entryConditionFocus, entryLocationFocus]);

  useEffect(() => {
    let hide;
    if (statusGift.isSuccess || statusGift.isFail) {
      hide = autoHideMessage();
    }
    return () => {
      clearTimeout(hide);
    };
  }, [statusGift]);

  return (
    <>
      {horizontal ? (
        <HorizontalGift giftData={giftData} handleOpenDetailInfo={setIsOpenDetailInfo} />
      ) : (
        <VerticalGift
          isMobile={isMobile}
          giftData={giftData}
          handleOpenDetailInfo={setIsOpenDetailInfo}
        />
      )}
      {isMobile ? (
        <Drawer
          opened={isOpenDetailInfo}
          onClose={() => setIsOpenDetailInfo(false)}
          size='xl'
          position='right'
          withCloseButton={false}
          padding={0}
          zIndex={100}
        >
          <div style={{ height: '90vh', overflow: 'scroll' }}>
            <PlusOutlined
              onClick={() => setIsOpenDetailInfo(false)}
              className='absolute left-4 top-4 z-50 mr-4 cursor-pointer rounded-full bg-white p-1'
              style={{
                color: '#000',
                fontSize: 20,
              }}
              rotate={45}
            />
            <img
              ref={ref}
              src={giftData.imageLink[0]?.fullLink}
              // src='assets/images/carousel/pc/Voucher2.png'
              className='h-[200px] w-screen object-cover'
              alt=''
            />
            <div className='my-2 font-roboto-regular text-14px'>
              <div
                className={`sticky top-0 z-40 px-6 pb-2 ${
                  isShowTabBubble ? 'drop-shadow-lg' : ''
                } bg-white`}
              >
                <p
                  className={`${
                    isShowTabBubble ? 'ml-7 pt-4' : 'ml-0'
                  } line-clamp-2 font-averta-regular text-20px transition-all ease-in-out`}
                >
                  {giftData.giftInfor.name}
                </p>
                <div className='mt-1 w-full'>
                  <p className='whitespace-nowrap text-0090F0'>
                    {format_curency(giftData.giftInfor.requiredCoin)} điểm
                  </p>
                  {/* <p className='whitespace-nowrap text-14px text-7B7B7B'>
                    Áp dụng đến:{' '}
                    <span className='font-roboto-regular text-0090F0'>
                      {date}/{month}/{year}
                    </span>
                  </p> */}
                </div>
                <div className='mt-3 flex justify-between'>
                  <p
                    className={`rounded-md border px-3 py-1 ${
                      isFocus === 1 ? 'border-0090F0 bg-[#E0F2FF]' : ''
                    }`}
                    onClick={() =>
                      infoRef.current.scrollIntoView({
                        behavior: 'smooth',
                      })
                    }
                  >
                    Thông tin
                  </p>
                  <p
                    className={`rounded-md border px-3 py-1 ${
                      isFocus === 2 ? 'border-0090F0 bg-[#E0F2FF]' : ''
                    }`}
                    onClick={() =>
                      conditionRef.current.scrollIntoView({
                        behavior: 'smooth',
                      })
                    }
                  >
                    Điều kiện sử dụng
                  </p>
                  <p
                    className={`rounded-md border px-3 py-1 ${
                      isFocus === 3 ? 'border-0090F0 bg-[#E0F2FF]' : ''
                    }`}
                    onClick={() =>
                      locationRef.current.scrollIntoView({
                        behavior: 'smooth',
                      })
                    }
                  >
                    Địa điểm
                  </p>
                </div>
              </div>
              <div className='mx-6 mt-1'>
                <div ref={infoRefFocus}>
                  <RenderHTML ref={infoRef} string={intro ? intro : ''} />
                </div>
                <div ref={conditionRefFocus}>
                  <RenderHTML ref={conditionRef} string={condition ? condition : ''} />
                </div>
                <div ref={locationRefFocus}>
                  <div ref={locationRef} className='w-full'>
                    <Location office={office} />
                  </div>
                </div>
              </div>
            </div>
            <div className='absolute bottom-0 flex w-full items-center justify-center border-t border-D9D9D9 bg-white pb-6 pt-3'>
              <div className='flex w-fit items-center justify-center rounded-md border border-D9D9D9 px-4 py-2'>
                <MinusOutlined
                  style={{
                    fontSize: '14px',
                    color: '#555',
                    padding: '5px',
                    backgroundColor: '#e9e9e9',
                  }}
                  onClick={() => setQuantity((pre) => (pre > 1 ? pre - 1 : 1))}
                />
                <p className='w-20 text-center text-16px'>{quantity}</p>
                <PlusOutlined
                  style={{
                    fontSize: '14px',
                    color: '#555',
                    padding: '5px',
                    backgroundColor: '#e9e9e9',
                  }}
                  onClick={() => setQuantity((pre) => pre + 1)}
                />
              </div>
              <div
                onClick={handleChangeGift}
                className='ml-6 rounded-4px bg-gradient-blue px-8 py-3 font-averta-semibold text-14px uppercase leading-18px text-white'
              >
                Đổi quà
              </div>
            </div>
            {giftData.giftInfor?.egift ? (
              <EgiftStatus
                data={giftData}
                quantity={quantity}
                status={statusGift}
                handleChangeStatus={setStatusGift}
                handleSubmitChangeGift={handleSubmitChangeGift}
              />
            ) : (
              // <></>
              <PhysicalGift
                data={giftData}
                status={statusGift}
                quantity={quantity}
                handleChangeStatus={setStatusGift}
                handleSubmitChangeGift={handleSubmitChangeGift}
              />
            )}
            {/* success */}
            <NotifySuccess
              handleShowGift={handleShowGift}
              isSuccess={statusGift.isSuccess}
              name={giftData?.giftInfor?.name}
              quantity={quantity}
            />
            {/* falure */}
            <NotifyFailure
              handleClose={() => {
                setStatusGift((prev) => {
                  return {
                    ...prev,
                    isFail: false,
                  };
                });
              }}
              isFail={statusGift.isFail}
              name={giftData?.giftInfor?.name}
              resson={statusGift.resson}
              quantity={quantity}
            />
          </div>
        </Drawer>
      ) : (
        <Modal
          size={860}
          radius={8}
          centered
          withCloseButton={false}
          opened={isOpenDetailInfo}
          onClose={() => setIsOpenDetailInfo(false)}
          padding={0}
          classNames={{
            modal: 'overflow-hidden',
          }}
        >
          <div className='flex items-center justify-between px-6 py-4'>
            <p className='line-clamp-2 font-averta-bold text-18px'>{giftData.giftInfor.name}</p>
            <div className='flex items-center'>
              <div className='flex w-fit rounded-4px border border-008BD2 bg-F2FAFF'>
                <p className='whitespace-nowrap px-5 py-2 font-averta-bold text-24px leading-18px text-0090F0'>
                  {format_curency(giftData.giftInfor.requiredCoin)} điểm
                </p>
                {/* <p className='whitespace-nowrap border-l border-008BD2 px-2 py-2 text-14px text-7B7B7B'>
                  Áp dụng đến:{' '}
                  <span className='font-roboto-bold text-0090F0'>
                    {date}/{month}/{year}
                  </span>
                </p> */}
              </div>
              <div className='ml-2 cursor-pointer' onClick={() => setIsOpenDetailInfo(false)}>
                <PlusOutlined rotate={45} style={{ color: '#000', fontSize: '20px' }} />
              </div>
            </div>
          </div>

          <TabsStyle>
            <Tabs defaultActiveKey={tabActive} onChange={setTabActive}>
              <Tabs.TabPane tab='Thông tin' key='1'>
                <ScrollArea style={{ height: '400px' }}>
                  <div className='flex justify-center'>
                    <img
                      src={giftData?.imageLink[0]?.fullLink || ''}
                      className='w-[350px]'
                      alt=''
                    />
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: `${intro ? intro : ''}` }}></div>
                </ScrollArea>
              </Tabs.TabPane>
              <Tabs.TabPane tab='Điều kiện sử dụng' key='2'>
                <ScrollArea style={{ height: '400px' }}>
                  <div dangerouslySetInnerHTML={{ __html: `${condition ? condition : ''}` }}></div>
                </ScrollArea>
              </Tabs.TabPane>
              <Tabs.TabPane tab='Địa điểm' key='3'>
                <div className='h-[400px] w-full'>
                  <Location office={giftData.giftInfor.office} />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </TabsStyle>
          <div className='mx-auto flex w-fit items-center justify-center bg-f5f5f5 py-2'>
            <div className='flex w-fit items-center justify-center rounded-4px border border-D9D9D9 bg-white px-4 py-2'>
              <MinusOutlined
                style={{
                  fontSize: '14px',
                  color: '#555',
                  padding: '5px',
                  backgroundColor: '#e9e9e9',
                }}
                onClick={() => setQuantity((pre) => (pre > 1 ? pre - 1 : 1))}
              />
              <p className='w-20 text-center text-16px'>{quantity}</p>
              <PlusOutlined
                style={{
                  fontSize: '14px',
                  color: '#555',
                  padding: '5px',
                  backgroundColor: '#e9e9e9',
                }}
                onClick={() => setQuantity((pre) => pre + 1)}
              />
            </div>
            <button
              className='ml-6 rounded-4px bg-gradient-blue px-8 py-3 font-averta-semibold text-14px uppercase leading-18px text-white'
              onClick={handleChangeGift}
            >
              Đổi quà
            </button>
          </div>
          {giftData.giftInfor?.egift ? (
            <EgiftStatus
              data={giftData}
              quantity={quantity}
              status={statusGift}
              handleChangeStatus={setStatusGift}
              handleSubmitChangeGift={handleSubmitChangeGift}
            />
          ) : (
            // <></>
            <PhysicalGift
              data={giftData}
              status={statusGift}
              quantity={quantity}
              handleChangeStatus={setStatusGift}
              handleSubmitChangeGift={handleSubmitChangeGift}
            />
          )}
          {/* success */}
          <NotifySuccess
            handleShowGift={handleShowGift}
            isSuccess={statusGift.isSuccess}
            name={giftData?.giftInfor?.name}
            fillInInformation={fillInInformation}
            quantity={quantity}
          />
          {/* falure */}
          <NotifyFailure
            handleClose={() => {
              setStatusGift((prev) => {
                return {
                  ...prev,
                  isFail: false,
                };
              });
            }}
            isFail={statusGift.isFail}
            name={giftData?.giftInfor?.name}
            resson={statusGift.resson}
            quantity={quantity}
          />
        </Modal>
      )}
    </>
  );
};

export default GiftItem;
